import { withGTM } from '@/features/shared/HOCs';
import {
  resolveBool,
  resolveColorName,
  resolveContentBlocks,
  resolveImage,
  resolveSpacingSize,
  resolveTheme,
} from '@/utils/resolvers';
import React, { useRef } from 'react';
import CMSWrapper from '../shared/CMSWrapper';
import RichContent from './RichContent';
import { mapTarget, onDatalayer } from './RichContent.datalayer';

const MappedRichContent = ({ content, presentation, contentButtons }: any) => {
  return (
    <div
      data-datalayer-position="rich_content"
      data-datalayer-variant={presentation?.datalayerVariant}
    >
      <RichContent {...content} {...presentation} contentButtons={contentButtons} />
    </div>
  );
};

const MappedRichContentGTM = withGTM({
  Component: MappedRichContent,
  onDatalayer,
  config: { mapTarget },
});

const RichContentCMSWrapper = (brProps: any) => {
  const mapping = useRef({
    document: [
      'content',
      {
        detailContent: [null, resolveContentBlocks],
        backgroundImage: [null, resolveImage],
        mobileBackgroundImage: [null, resolveImage],
      },
    ],
    componentParameterMap: [
      'presentation',
      {
        includeHorizontalDivider: [null, resolveBool],
        'text-color': ['theme', resolveTheme('text-color')],
        'container-top-background-color': ['containerTopBackgroundColor', resolveColorName],
        'container-bottom-background-color': ['containerBottomBackgroundColor', resolveColorName],
        'container-inset-width': 'containerInsetWidth',
        'top-spacing': ['topSpacing', resolveSpacingSize],
        'bottom-spacing': ['bottomSpacing', resolveSpacingSize],
        'variant-label': 'datalayerVariant',
      },
    ],
  });

  const requiredFields = useRef({
    document: '<b>Content</b> required',
  });

  const contentButtonNames = useRef({
    document: 'content',
  });

  return (
    <CMSWrapper
      brProps={brProps}
      render={MappedRichContentGTM}
      mapping={mapping.current}
      requiredFields={requiredFields.current}
      contentButtonNames={contentButtonNames.current}
    />
  );
};

export default RichContentCMSWrapper;
